import adminTool from './mainTranslation.json';
import ownerPortal from './ownerPortalTranslation.json';

const translations = { ...adminTool, ...ownerPortal };

export default translations;
